<div class="dashboard-wrapper">
  <!-- Header -->
  <div class="header-section mb-4">
    <h5 class="fw-semibold text-muted">Here’s what’s going on at your service line right now</h5>
    <h2 class="text-indigo">
      {{ approvalCounts.approved + approvalCounts.pending + approvalCounts.rejected }} new appraisals
    </h2>
  </div>

  <!-- Stat Tiles -->
  <div class="stat-tiles">
    <mat-card class="tile-card approved-tile">
      <mat-icon class="tile-icon">check_circle</mat-icon>
      <div>
        <h6>Approved</h6>
        <span class="count">{{ approvalCounts.approved }}</span>
      </div>
    </mat-card>

    <mat-card class="tile-card pending-tile">
      <mat-icon class="tile-icon">schedule</mat-icon>
      <div>
        <h6>Pending</h6>
        <span class="count">{{ approvalCounts.pending }}</span>
      </div>
    </mat-card>

    <mat-card class="tile-card rejected-tile">
      <mat-icon class="tile-icon">cancel</mat-icon>
      <div>
        <h6>Rejected</h6>
        <span class="count">{{ approvalCounts.rejected }}</span>
      </div>
    </mat-card>
  </div>

  <hr class="mb-6 mt-4" />

  <!-- Chart Cards -->
  <div class="chart-card-container">
    <mat-card class="chart-card border-blue">
      <mat-card-header>
        <mat-card-title>Appraisals by Property Type</mat-card-title>
        <mat-card-subtitle>All property types</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <ag-charts *ngIf="propertyTypeChart" [options]="propertyTypeChart"></ag-charts>
      </mat-card-content>
    </mat-card>

    <mat-card class="chart-card border-yellow">
      <mat-card-header>
        <mat-card-title>Office Appraisals by City</mat-card-title>
        <mat-card-subtitle>Office properties</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <ag-charts *ngIf="officeCityChart" [options]="officeCityChart"></ag-charts>
      </mat-card-content>
    </mat-card>

    <mat-card class="chart-card border-green">
      <mat-card-header>
        <mat-card-title>Year Built Distribution</mat-card-title>
        <mat-card-subtitle>Office Properties</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <ag-charts *ngIf="yearBuiltChart" [options]="yearBuiltChart"></ag-charts>
      </mat-card-content>
    </mat-card>

    <mat-card class="chart-card border-grey">
      <mat-card-header>
        <mat-card-title>Vacancy Distribution</mat-card-title>
        <mat-card-subtitle>Office Properties</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <ag-charts *ngIf="vacancyChart" [options]="vacancyChart"></ag-charts>
      </mat-card-content>
    </mat-card>

    <mat-card class="chart-card border-dark-red">
      <mat-card-header>
        <mat-card-title>Capitalization Rate by Property</mat-card-title>
        <mat-card-subtitle>Available properties with cap rate</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <ag-charts *ngIf="capRateChart" [options]="capRateChart"></ag-charts>
      </mat-card-content>
    </mat-card>
  </div>
</div>
